/* eslint-disable consistent-return */
import { Mongo } from 'meteor/mongo';
import SimpleSchema from 'simpl-schema';

const UserControl = new Mongo.Collection('UserControl');

UserControl.allow({
  insert: () => false,
  update: () => false,
  remove: () => false
});

UserControl.deny({
  insert: () => true,
  update: () => true,
  remove: () => true
});

const userSchema = new SimpleSchema({
  free: {
    type: Number,
    label: 'The number.',
    autoValue() {
      if (this.isInsert) {
        return 5;
      }
    }
  },
  basic: {
    type: Number,
    label: 'The number',
    autoValue() {
      if (this.isInsert) {
        return 10;
      }
    }
  }
});

const UserControlSchema = new SimpleSchema({
  advancedComponents: {
    type: Array,
    label: 'The list that have permission to upload layer',
    autoValue() {
      if (this.isInsert) {
        return [
          'AnnotationDirectButtons',
          'CatastroComponent',
          'DownloadLinksComponent',
          'FileToolsComponent',
          'InfoLayerSelection',
          'ISLComponent',
          'IntroductionMapComponent',
          'LayersControl',
          'LocationComponent',
          'NotesComponent',
          'PointMapComponent',
          'PythonComponent',
          'SentinelComponent',
          'SharedComponent',
          // 'ShowMapDeckLidarComponent',
          'TableAnnotationsComponent',
          'TableSourceComponent',
          'ViewLinksComponent'
        ];
      }
    }
  },
  'advancedComponents.$': {
    type: String,
    label: 'The list of user roles that have permission'
  },
  defaultMapCenter: {
    type: Object,
    label: 'The list that have permission to upload layer',
    blackbox: true
  },
  defaultBaseMap: {
    type: String,
    label: 'Default base layer that displays the map.',
    optional: true
  },
  downloadLayer: {
    type: Array,
    label: 'The list that have permission to upload layer',
    autoValue() {
      if (this.isInsert) {
        return ['admin'];
      }
    }
  },
  'downloadLayer.$': {
    type: String,
    label: 'The list of user roles that have permission'
  },
  downloadMap: {
    type: Array,
    label: 'The list that have permission to upload layer',
    autoValue() {
      if (this.isInsert) {
        return ['admin'];
      }
    }
  },
  'downloadMap.$': {
    type: String,
    label: 'The list of user roles that have permission'
  },
  hasTrash: {
    type: Array,
    label: 'The list that have permission to upload layer',
    autoValue() {
      if (this.isInsert) {
        return ['admin'];
      }
    }
  },
  'hasTrash.$': {
    type: String,
    label: 'The list of user roles that have permission'
  },
  numberLayersCreated: {
    type: userSchema,
    label: 'The list that have permission to upload layer'
  },
  numberMapsCreated: {
    type: userSchema,
    label: 'The list that have permission to upload layer'
  },
  uploadLayer: {
    type: Array,
    label: 'The list that have permission to upload layer',
    autoValue() {
      if (this.isInsert) {
        return ['admin'];
      }
    }
  },
  'uploadLayer.$': {
    type: String,
    label: 'The list of user roles that have permission'
  },
  uploadMap: {
    type: Array,
    label: 'The list that have permission to upload map',
    autoValue() {
      if (this.isInsert) {
        return ['admin'];
      }
    }
  },
  'uploadMap.$': {
    type: String,
    label: 'The list of user roles that have permission'
  },
  tutorial: {
    type: Array,
    label: 'The list that have permission to upload map',
    autoValue() {
      if (this.isInsert) {
        // Establece el valor predeterminado solo en la inserción de documentos nuevos
        return [
          {
            title: 'IpsiluMaps',
            _id: Array.from({ length: 18 }, () => Math.random().toString(36)[2]).join(''),
            properties: [
              {
                value: 'https://i.ytimg.com/vi/WjS-oxDqJns/hqdefault.jpg',
                type: 'imagen',
                name: 'Imagen ipsilum'
              }
            ]
          }
        ];
      }
    }
  },
  'tutorial.$': {
    type: Object,
    label: 'An object containing the id of the base map and the transparency value',
    blackbox: true
  },
  defaultUserRole: {
    type: String,
    label: 'The list of user roles that have permission',
    autoValue() {
      if (this.isInsert) {
        return 'basic-user';
      }
    }
  },
  value: {
    type: SimpleSchema.oneOf(Boolean, Number, String),
    label: 'The value for the setting',
    autoValue() {
        // eslint-disable-line
      // NOTE: Pass default value as a string to get around this:
      // https://github.com/aldeed/simple-schema-js/issues/169
      const type = this.field('type');
      if (type.value) {
        return {
            boolean: this.value == 'true', // eslint-disable-line
          string: this.value,
          number: parseInt(this.value, 10)
        }[type.value];
      }
      return undefined;
    },
    optional: true
  }
});

UserControl.attachSchema(UserControlSchema);

export default UserControl;
